<template>
  <div>
    <transition name="fade" mode="out-in">
      <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="accountTerminatedChanged" @dismiss-count-down="countDownChanged">
        <template v-if="checkVariable(searchedResult) && getAmountOfKeys(searchedResult) > 0">
          <div v-for="(finder, index) in searchedResult" :key="`finder-index-${index}`">
            <template v-if="checkVariable(finder.route) && isObject(finder.route)">
              <hr>
              <a href="#" v-on:click.prevent="goToTheResource(finder.route)"><h4 class="alert-heading">{{ finder.name }}</h4></a>
            </template>
          </div>
        </template>
        <template v-else>
          <h3 class="alert-heading text-danger">{{ $t('there_is_no_information') }}</h3>
        </template>
      </b-alert>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'vue-showsearch',
  computed: {
    ...mapGetters({
      'loadingSearchedResult': 'loadingSearchedResult',
      'searchedResult': 'searchedResult',
      'errorSearchedResult': 'errorSearchedResult',
    }),
  },
  data() {
    return {
      dismissCountDown: 0,
    }
  },
  watch: {
    'searchedResult': {
      deep: true,
      handler() {
        if (this.loadingSearchedResult === false && this.getAmountOfKeys(this.searchedResult) === 0) {
          this.dismissCountDown = 10
        } else {
          this.dismissCountDown = this.getAmountOfKeys(this.searchedResult) > 0 ? 1000 : 0
        }
      },
    },
  },
  methods: {
    accountTerminatedChanged() {
      this.dismissCountDown = 0

      this.$store.commit('GET_SEEKER_START')
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    goToTheResource(route) {
      this.pushRoute(route)

      this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

      this.accountTerminatedChanged()
    },
  },
}
</script>
